
import * as vercelRuntime$i7ZKjk23q6wpN1972_45RJjAcFo9ojzmoU9p9GoLDymBQ from '/vercel/path0/packages/ddc-giving-circle/node_modules/.pnpm/@nuxt+image@1.10.0_db0@0.3.2_ioredis@5.6.1_magicast@0.3.5/node_modules/@nuxt/image/dist/runtime/providers/vercel'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536,
    "ogImage": 1200
  },
  "presets": {},
  "provider": "vercel",
  "domains": [
    "givingcircles.io"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['vercel']: { provider: vercelRuntime$i7ZKjk23q6wpN1972_45RJjAcFo9ojzmoU9p9GoLDymBQ, defaults: {} }
}
        